import { Fragment } from 'react';
import type { ShouqianbaPaymentDetails } from '@redd/contracts';

export function PaymentDetails({ details, grid = false }: { details?: ShouqianbaPaymentDetails | undefined; grid?: boolean }) {
  if (!details) return null;
  const money = (fen: number) => '¥' + (fen / 100).toFixed(2);
  const fields: [string, string | undefined][] = [
    ['收钱吧订单号', details.orderSn],
    ['收钱吧支付流水号', details.payTsnList.join('、')],
    ['收单号', details.acquiringSn],
    ['下单请求号', details.requestId],
    ['预订单 ID', details.preOrderId],
    ['收钱吧商户号', details.merchantSn],
    ['收钱吧门店号', details.storeSn],
    ['收钱吧商城号', details.mallSn],
    ['买家实付', money(details.amount.actualAmountFen)],
    ['商户实收', details.amount.receivedAmountFen === undefined ? undefined : money(details.amount.receivedAmountFen)],
    ['支付方式', details.paymentInfoList?.map(item => item.payWayDesc).filter(Boolean).join('、')],
  ];
  return <>{fields.filter(([, value]) => value !== undefined && value !== '').map(([label, value]) => grid
    ? <div className="detail-item" key={label}><span>{label}</span><strong style={{ overflowWrap: 'anywhere' }}>{value}</strong></div>
    : <Fragment key={label}><dt>{label}</dt><dd style={{ overflowWrap: 'anywhere' }}>{value}</dd></Fragment>)}</>;
}
